module.exports = __webpack_public_path__ + "static/media/gismallbr.8d91034e.jpg";